import React from 'react';
import PropTypes from 'prop-types';
import { get, isEmpty } from 'lodash';
import { Field } from 'redux-form';
import { Grid } from '@material-ui/core';
import Icon from 'components/Icon';
import Error from 'components/forms/Error';
import { HEADERS_SECTION } from 'constants/contact';
import { requiredOptionValidator, handleBlur } from 'utils/validators';
import { getFieldName } from 'utils/contact';
import Select from 'components/forms/Select';
import startCase from 'lodash/startCase';


const getSampleEntryValue = (values, fieldName) => {
  const fieldPath = [HEADERS_SECTION, ...fieldName.split('.'), 'value'];
  return isEmpty(get(values, fieldPath)) ? 'Sample entry value' : get(values, fieldPath);
};

const CsvFieldMap = ({ csvField, renderedHeaders, values }) => (
  <Grid container key={csvField.id} className="template-row">
    <Grid item sm={5} className="map-from">
      <p className="field-label">
        {startCase(csvField.name)}
        {csvField.is_required && <span className="required">*</span>}
      </p>
      <p>{getSampleEntryValue(values, getFieldName(csvField))}</p>
    </Grid>
    <Grid item sm={1} className="map-arrow">
      <Icon name="arrow-right" />
    </Grid>
    <Grid item sm={6} className="map-to">
      <Field
        name={getFieldName(csvField)}
        onBlur={handleBlur}
        validate={csvField.is_required ? [requiredOptionValidator] : []}
        component={propsCus => (
          <React.Fragment>
            <Select
              placeholder="Column name"
              value={propsCus.input.value}
              onChange={propsCus.input.onChange}
              onBlur={() => propsCus.input.onBlur(propsCus.input.value)}
              options={renderedHeaders}
              isClearable
            />
            {propsCus.meta.touched &&
              propsCus.meta.error && <Error error={propsCus.meta.error} />}
          </React.Fragment>
        )}
      />
    </Grid>
  </Grid>
);

CsvFieldMap.propTypes = {
  csvField: PropTypes.shape({}).isRequired,
  renderedHeaders: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  values: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default CsvFieldMap;
